import React from "react";

const StatCard = ({ icon, cardBg, label, value }) => {
    return (
        <div
            className={`p-5 rounded-lg ${cardBg} flex flex-1 flex-row items-start gap-4`}
        >
            <div
                className={`flex items-center justify-center gap-1`}
            >
                <img
                    src={icon}
                    alt="stat-icon"
                    className="w-8 h-8 pointer-events-none"
                />
            </div>

            <div className="flex flex-col items-start gap-2">
                <p className="capitalize font-inter font-medium text-ec-body">
                    {label}
                </p>
                <p className="text-xl font-inter font-semibold text-ec-title">
                    {value}
                </p>
            </div>
        </div>
    );
};

export default StatCard;
